import { render } from "./SeleccionBuscador.vue?vue&type=template&id=2bdd2546&scoped=true"
import script from "./SeleccionBuscador.vue?vue&type=script&lang=js"
export * from "./SeleccionBuscador.vue?vue&type=script&lang=js"

import "./SeleccionBuscador.vue?vue&type=style&index=0&id=2bdd2546&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdd2546"]])

export default __exports__